import { render, staticRenderFns } from "./projetos.captacao.vue?vue&type=template&id=11722959&"
import script from "./projetos.captacao.vue?vue&type=script&lang=js&"
export * from "./projetos.captacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports